// src/components/PartnerLogos.js
import React, {useEffect, useRef} from 'react';
import {useDateSponsor} from "../hooks/useDateSponsor";
import Loading from "./Loading";
import ErrorAlert from "./ErrorAlert";

const LogoItem = ({title, images = ""}) => {
    return (
        <div className="logoBox">
            <h3>{title}</h3>
            <p>
                {images.map((img, index) => (
                    <a href={img.link || "#"}>
                        <img src={img.imageIdUrl} alt=""/>
                    </a>
                ))}
            </p>

        </div>
    );
};

const LogoMarquee = ({title, images}) => {
    const marqueeRef = useRef(null);

    useEffect(() => {
        const marquee = marqueeRef.current;
        if (!marquee) return;

        const baseDuration = 1;
        const uls = marquee.querySelectorAll("ul");

        // 避免重複 clone
        if (uls.length > 2) return;

        const ul = uls[0];
        if (!ul) return;

        const clonedLists = Array.from({length: 2}, () => ul.cloneNode(true));
        clonedLists.forEach(cloned => marquee.appendChild(cloned));

        const totalItems = ul.querySelectorAll("li").length * 3;
        const totalDuration = baseDuration * totalItems;

        marquee.querySelectorAll("ul").forEach(ulEl => {
            ulEl.style.setProperty("--marquee-duration", `${totalDuration}s`);
        });
    }, [images]);

    return (
        <div className="logoBox">
            <h3>{title}</h3>
            <div className="marquee" ref={marqueeRef}>
                <ul>
                    {images.map((img, index) => (
                        <li key={`marquee-1-${index}`}>
                            <a href={img.link || "#"}>
                                <img src={img.imageIdUrl} alt="Marquee"/>
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

const PartnerLogos = () => {

    const {data: sponsorData, isLoading: loading, isError: error} = useDateSponsor();

    return (
        <section className="areaPartner">
            <div className="wrap">
                {loading && <Loading/>}
                {error && <ErrorAlert/>}
                {!loading && sponsorData.content.map((sponsor, index) => (
                    // sponsor?.dateSponsorDetails?.length === 1 ? (
                        <LogoItem key={index} title={sponsor.categoryName} images={sponsor.dateSponsorDetails} />
                    // ) : (
                    //  <LogoMarquee key={index} title={sponsor.categoryName} images={sponsor.dateSponsorDetails}/>
                    // )
                ))}

            </div>
        </section>
    );
};

export default PartnerLogos;
